import {
    get,
    post,
    axios,
} from "../ApiDecorator";

/**
 * 报告管理 V2（/course/admin/v2/report）
 * 模板样例只读 templateSample。系统提示词在管理后台维护，展示端不调用 /ai。
 */
const ReportV2 = {
    /** GET 报告列表 */
    getList(data) {
        return get("/course/admin/v2/report/list", data);
    },
    /** GET 可选模板（启用且范围含三段九环） */
    getTemplates(data) {
        return get("/course/admin/v2/report/templates", data);
    },
    /** GET 本报告的总提示词和章节说明 */
    getOutline(data) {
        return get("/course/admin/v2/report/outline", data);
    },
    /** GET 模板结果样例。sampleNo 省略时为最新已完成版 */
    getTemplateSample(data) {
        return get("/course/admin/v2/report/templateSample", data);
    },
    /** GET 已启用模型，下拉用 name，保存用 code 作为 aiProvider */
    getModels() {
        return get("/course/admin/v2/report/models");
    },
    /** GET 数据范围选项 */
    getScopeOptions(data) {
        return get("/course/admin/v2/report/scopeOptions", data);
    },
    /** POST 保存草稿，成功 data 为报告 id */
    save(data) {
        return post("/course/admin/v2/report/save", data);
    },
    /** POST 只改名称 */
    rename(data) {
        return post("/course/admin/v2/report/rename", data);
    },
    /** POST 逻辑删除 */
    deleteReport(data) {
        return post("/course/admin/v2/report/delete", data);
    },
    /** POST 取消发布 */
    unpublish(data) {
        return post("/course/admin/v2/report/unpublish", data);
    },
    /** POST 数据处理，成功 data 为任务 id */
    prepare(data) {
        return post("/course/admin/v2/report/prepare", data);
    },
    /** GET 进度，taskType=prepare|generate，afterId 增量拉日志 */
    getProgress(data) {
        return get("/course/admin/v2/report/progress", data);
    },
    /** POST 停止任务 */
    stop(data) {
        return post("/course/admin/v2/report/stop", data);
    },
    /** POST 继续任务，已完成项不重跑 */
    continueTask(data) {
        return post("/course/admin/v2/report/continue", data);
    },
    /** POST 开始生成，须先有一次成功的数据处理 */
    generate(data) {
        return post("/course/admin/v2/report/generate", data);
    },
    /** GET 发布版本 */
    getVersions(data) {
        return get("/course/admin/v2/report/versions", data);
    },
    /** GET 预览正文 */
    getPreview(data) {
        return get("/course/admin/v2/report/preview", data);
    },
    /** POST 保存当前版本正文，不新建发布版本 */
    saveContent(data) {
        return post("/course/admin/v2/report/saveContent", data);
    },
    /** POST 报告调整，成功 data 为新生成任务 id */
    adjust(data) {
        return post("/course/admin/v2/report/adjust", data);
    },
    /** POST 删除未发布的历史版本 */
    deleteVersion(data) {
        return post("/course/admin/v2/report/deleteVersion", data);
    },
    /** POST 发布指定版本 */
    publish(data) {
        return post("/course/admin/v2/report/publish", data);
    },
    /** POST 发起导出，成功 data 为任务 id。不用 /export，避免鉴权白名单放行 */
    exportReport(data) {
        return post("/course/admin/v2/report/exportAsync", data);
    },
    /** GET 导出任务状态 */
    getExportStatus(data) {
        return get("/course/admin/v2/report/exportStatus", data);
    },
    /** GET 下载导出文件（文件流） */
    download(data) {
        const params = { ...data, noCache: new Date().getTime() };
        const query = Object.keys(params)
            .filter(key => params[key] !== undefined && params[key] !== null && params[key] !== "")
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
            .join("&");
        return axios.get(`/course/admin/v2/report/download?${query}`, {
            responseType: "blob",
        });
    },
};

export default ReportV2;
